import { FC, useContext } from 'react';
import { StyledContainer, StyledKey, StyledValue } from './styles';
import Typography from '@mui/material/Typography';
import { useRouter } from 'next/navigation';
import { reducerTypes } from '../../../store/Product/types';
import { useAppDispatch } from 'src/hooks/reduxHooks';
import styles from './styles.module.css';
import { buildRoute } from '../../../utils/routerPathBuilder';
import { LanguageContext } from '../../../providers/LanguageProvider';
import LocalizedLink from '../../../components/Link/localized-link';

export interface IFeaturesItem {
  id?: string;
  key: string;
  value?: string | undefined;
  urlSlug?: string;
}

interface IProps {
  data: IFeaturesItem[];
  activeCols: string[];
  onlyKeys?: boolean;
  onlyValues?: boolean;
}

const FeaturesItems: FC<IProps> = ({ data, activeCols, onlyKeys, onlyValues }) => {
  const dispatch = useAppDispatch();
  const navigate = useRouter();
  const { lang } = useContext(LanguageContext);

  async function changeToFilters(item: IFeaturesItem) {
    if (!activeCols.includes(item.key)) return;
    const BrandName = data.filter((item) => item.key === 'BrandName')[0];
    dispatch({ type: reducerTypes.GET_ALL_PRODUCTS, payload: [] });
    switch (item.key) {
      case 'ModelName':
        navigate.push(
          buildRoute(
            encodeURI(
              `/all-watches/${BrandName.urlSlug || BrandName.value}?${item?.key}=${item?.urlSlug || item?.value}`
            ),
            lang
          )
        );
        break;
      case 'BrandName':
        navigate.push(buildRoute(encodeURI(`/all-watches/${item?.urlSlug || item.value}`), lang));
        break;
    }
  }

  function getRoute(item: IFeaturesItem) {
    if (item.key === 'ModelName') {
      const BrandName = data.filter((item) => item.key === 'BrandName')[0];
      return buildRoute(
        encodeURI(`/all-watches/${BrandName.urlSlug || BrandName.value}?${item?.key}=${item?.urlSlug || item?.value}`),
        lang
      );
    }
    if (item.key === 'BrandName') {
      return buildRoute(encodeURI(`/all-watches/${item?.urlSlug || item?.value}`), lang);
    }

    return '';
  }

  return (
    <div>
      {data
        ?.filter((item) => onlyKeys || onlyValues || item.value || item.key === 'Case diameter')
        ?.map((item, index) => (
          <StyledContainer key={index}>
            {!onlyValues && (
              <StyledKey>
                <Typography variant={'h4'} sx={{ color: '#535353' }}>
                  {item.key.replace('Name', ' Name').toUpperCase()}
                </Typography>
              </StyledKey>
            )}

            {!onlyKeys && (
              <StyledValue
                className={`${activeCols.includes(item.key) ? styles.active : ''}`}
                sx={{ minHeight: '36px' }}
                onClick={() => changeToFilters(item)}
              >
                {activeCols.includes(item.key) && item.urlSlug && getRoute(item) ? (
                  <LocalizedLink href={getRoute(item)}>{item.value || 'Not indicated'}</LocalizedLink>
                ) : (
                  <span>{item.value || 'Not indicated'}</span>
                )}
              </StyledValue>
            )}
          </StyledContainer>
        ))}
    </div>
  );
};

export default FeaturesItems;
